export { default, getBGStyle } from './Sprite';